/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'ai-mate.chat-error.description': 'Essayez de <btn>recharger le chat</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Vous avez atteint le nombre maximal de demandes. Veuillez réessayer ultérieurement.',
  'ai-mate.chat-error.rate-limited-title': 'Trop de demandes',
  'ai-mate.chat-error.title': "Nous ne savons pas ce qui s'est passé",
  'conversation-assistant-button.label': 'Chat',
  'horizontal-scroll-container.scroll-left': 'Faire défiler vers la gauche',
  'horizontal-scroll-container.scroll-right': 'Faire défiler vers la droite',
};
